export default {
  en_US: {
    name: 'Name',
    slogan: 'A Leading Crypto Exchange serving hundreds of thousands of users',
    latestPrice: 'Latest price',
    oneDayChanges: 'Price move(24H)',
    threeYearsChanges: 'Price move( last 3 years)',
    marketCap: 'Market cap',
    aboutUs: 'About Us',
    subAboutUs: 'About Us',
    business: 'Business Cooperation',
    community: 'Community',
    serviceAgreement: 'Service Agreement',
    privacyProtection: 'Privacy Protection',
    products: 'Products',
    digitalTrading: 'Crypto Trading',
    fiatRecharge: 'Fiat Deposit',
    digitalPurchases: 'Buy Crypto',
    charity: 'Mal.io Charity',
    services: 'Services',
    clientDownload: 'Client Download',
    listingApplication: 'Token Listing Application',
    rateStandard: 'Fee Rates',
    invitations: 'Referral program',
    historicalData: 'Historical data',
    help: 'Help',
    helpCenter: 'Help Center',
    onlineCustomerService: 'Online Customer Service',
    suggestionsAndFeedback: 'Suggestions And Feedback',
    announcementCenter: 'Announcement Center',
    financeGateway: 'Your Crypto Finance Gateway',
    joinNow: 'Join Now',
    socialMedia: 'Social media',
    registerNow: 'Register now',
    invitationRebate: 'Referral program',
    joinTheCommunity: 'Join the community',
    joinCommunityDesc: 'Join the community with  industry\'s top investors',
    suggestionsDesc: 'If you have any suggestions for the Mal.io platform, please contact us via email:  info@mal.io',
    stayTuned: 'Stay tuned',
    stayDesc: 'The NFT project of the Mal.io platform is under development . KYCed users will get some of it.',
    cancel: 'Cancel',
    copyEmail: 'Copy Email',
    aboutTitle: 'A Leading Crypto Exchange serving hundreds of thousands of users',
    aboutOneTitle: 'Elite management team',
    aboutOneDesc: "The Mal.io team is composed of financial experts, information technology experts, and security experts from the world's top financial and Internet companies, and is committed to providing professional digital asset issuance, custody, trading, and wealth management services to global users. The platform has offices or branches in the UAE and the Kingdom of Bahrain. In 2021, we received investment from many well-known institutions such as Huobi ventures, Colinstar capital, and waterdrop capital.",
    aboutTwoTitle: 'Leading Technology and Products',
    aboutTwoDesc: `Mal.io  adopts a leading third-generation trading system, with 99.99% SLA, extremely low latency and high throughput, ensuring the security of users' assets and trade smoothly;  users can use the platform on  Web\IOS\android ;
    provides our users with a variety of blockchain assets including crypto currency, DeFi and GameFi assets, Web3 applications, and NFT.`,
    aboutThreeTitle: 'Strict compliance and auditing',
    aboutThreeDesc: "Mal.io  adheres to a strict  KYC and AML system, as it holds a financial license; the platform adopts international general financial management standards, and employs third-party organizations for regular audits to ensure the security of users' financial data",
    threeIncrease: 'BTC price move( 3years)',
    noviceTeaching: 'Beginners learning',
    buyCurrency: 'Buy digital currency',
    feeRates: 'Fee Rates',
    transactionFee: 'Trading fee',
    buyerFee: 'Taker fee',
    sellerFee: 'Maker fee',
    tradingPair: 'Trading pair',
    withdrawalLimit: 'Withdrawal limit',
    currency: 'Token',
    close: 'Close',
    kycVerification: 'KYC Verification',
    buyUSDT: 'Buy USDT',
    invest: 'Invest',
    businessDesc: 'For business, please contact us through email info@mal.io',
    language: 'language',
  },
  ar_SA: {
    name: 'العملة',
    slogan: 'منصة تداول عملات مشفرة رائدة، تخدم مئات الآلاف من المستخدمين',
    latestPrice: 'آخر سعر',
    oneDayChanges: 'صعود وهبوط (24H)',
    threeYearsChanges: 'نسبة الصعود (آخر ثلاث سنوات)',
    marketCap: 'القيمة السوقية',
    aboutUs: 'معلومات عنا',
    subAboutUs: 'من نحن؟',
    business: 'التعاون التجاري',
    community: 'مجتمعنا',
    serviceAgreement: 'اتفاقية الخدمات',
    privacyProtection: 'حماية الخصوصية',
    products: 'منتجات',
    digitalTrading: 'تداول العملات الرقمية',
    fiatRecharge: 'إيداع بالعملة المحلية',
    digitalPurchases: 'شراء عملات مشفرة',
    charity: 'مال الخيرية Mal.io',
    services: 'خدمات',
    clientDownload: 'تحميل التطبيق ',
    listingApplication: 'تقديم لإدراج عمله',
    rateStandard: 'الرسوم',
    feeRates: 'الرسوم',
    invitations: 'برنامج الاحالة (شركاء مال)',
    historicalData: 'البيانات التاريخية" سجل البيانات"',
    help: 'مساعدة',
    helpCenter: 'مركز المساعدة',
    onlineCustomerService: 'خدمة العملاء عبر الإنترنت',
    suggestionsAndFeedback: 'الاقتراحات والملاحظات',
    announcementCenter: 'مركز الاعلانات',
    financeGateway: 'منصة مال بوابتك المالية في العملات المشفره و الويب ٣ ',
    joinNow: 'انضم الان',
    socialMedia: 'وسائل التواصل الاجتماعي',
    registerNow: 'سجل الآن ',
    invitationRebate: 'برنامج الاحالة',
    joinTheCommunity: 'الانضمام إلى المجتمع',
    joinCommunityDesc: 'انضم إلى المجتمع  مع كبار المستثمرين في هذا المجال',
    suggestionsDesc: 'إذا كان لديك أي اقتراحات لمنصة Mal.io ، يرجى التواصل معنا عبر البريد الإلكتروني  info@mal.io',
    cancel: 'إلغاء',
    copyEmail: 'نسخ البريد الإلكتروني',
    stayTuned: 'ترقبوا!',
    stayDesc: 'مشروع NFT لمنصة Mal.io قيد التطوير.  سيتم توزيع هدايا NFT لمن اتمم التوثيق.',
    aboutTitle: 'منصة تداول عملات مشفرة رائدة، تخدم مئات الآلاف من المستخدمين`',
    aboutOneTitle: 'نخبة من الاداريين',
    aboutOneDesc: 'تأسست منصة مال  العربية في عام 2021 ، لتكن من اهم البوابات لسوق العملات المشفره في المنطقه، أغلقنا جوله استثماريه من العديد من الشركات  المعروفة في قطاع الكريبتو ، مثل huobi ventutres و colinstar Capital و waterdrip Capital.للمنصة فروع في الإمارات العربية المتحدة ومملكة البحرين. لدى فريق Mal.io خبره معتبره في مجال المال و التكنولوجيا، عملنا من قبل في أهم الشركات المالية وشركات الإنترنت في العالم ، ملتزمون بتزويد كل المستخدمين حول العالم بمنتجات وخدمات عمليه،  مثل إصدار الأصول المشفرة، تداول الاصول المشفرة،  وإدارة الثروات المالية.',
    aboutTwoTitle: 'تكنولوجيا و منتجات رائدة',
    aboutTwoDesc: `
    تتبنى منصة mal.io نظام تداول رائد من الجيل الثالث مع ضمان تشغيل الخدمة بنسبة 99.99٪ (SLA) ، نظام تزامن متعدد وعالي الكفائه ، مما يضمن سلاسة التداول لعملاء المنصة ؛
    يمكن  للمستخدمين استخدام المنصة من خلال ال Web \ IOS \ android ؛ نوفر لعملائنا  مجموعة متنوعة من الاصول الرقميه على  البلوكتشين  بما في ذلك العملات المشفرة  وأصول DeFi و GameFi و NFT والوصول الى تطبيقات الـ Web3 .
    `,
    aboutThreeTitle: 'الامتثال الصارم والتدقيق',
    aboutThreeDesc: 'تلتزم منصة Mal بنظام KYC و AML بشكل صارم ، ولدينا ترخيص مالي؛ تتبنى المنصة معايير الإدارة المالية العامة الدولية ، نوظف جهات خارجية لإجراء عمليات تدقيق منتظمة لضمان أمن وصحة البيانات المالية للمستخدمين',
    threeIncrease: 'ارتفاع البيتكوين (اخر ٣ سنوات)',
    noviceTeaching: 'تعليم المبتدئين',
    buyCurrency: 'شراء العملات الرقمية',
    rateFtandard: 'معيار المعدل',
    transactionFee: 'رسوم التداول',
    buyerFee: 'رسوم المشتري',
    sellerFee: 'رسوم البائع',
    tradingPair: 'زوج تداول',
    withdrawalLimit: 'حد السحب',
    currency: 'العملة',
    close: 'إغلاق',
    kycVerification: 'التحقق من KYC',
    buyUSDT: 'شراء USDT',
    invest: 'استثمر',
    businessDesc: 'للتعاون التجاري ، يرجى التواصل معنا عبر البريد الإلكتروني info@mal.io',
    language: 'لغة',
  },
};
